export const importExport = {
	importEntriesDialog: {
		summary: {
			loadedToCart: 'Product has been loaded to cart {{ cartName }}',
			messages: {
				limitedPartialAvailability: 'Quantity Not Available. "{{ productCode }}" has limited availability: {{ availableInventory }} unit(s) available. The item was not added, please reduce the requested quantity and try again.',
				limitedNoAvailability: 'Product Unavailable. "{{ productCode }}" is no longer in stock and will not be restocked. The item was not added to your cart.',
				limitedQuantityAdjusted: 'Quantity for "{{ productCode }}" was adjusted to {{ availableInventory }} based on current inventory availability.'
			}
		}
	},
	exportEntries: {
		exportProductToCsv: 'Export to CSV',
		columnNames: {
			price: 'Total price',
			unitPrice: 'Unit price',
			code: 'Model'
		}
	}
};